"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var $ = require("jquery");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var MobileHideButtonComponent = (function (_super) {
    __extends(MobileHideButtonComponent, _super);
    function MobileHideButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.isDisliked = ko.observable(false);
        this.isSeriesHidden = ko.observable(false);
        this.hiddenAuthorIds = ko.observableArray([]);
        this.isHidden = ko.observable(false);
        this.getHideOptions = ko.pureComputed(function () {
            var hideOptions = [];
            var isHidden = false;
            if (_this.workId) {
                if (_this.isDisliked()) {
                    hideOptions.push({ command: "Hide", text: "Скрывать произведение", icon: "icon-book", checked: true });
                    isHidden = true;
                }
                else {
                    hideOptions.push({ command: "Hide", text: "Скрыть произведение", icon: "icon-book", checked: false });
                }
            }
            if (_this.seriesId) {
                if (_this.isSeriesHidden()) {
                    hideOptions.push({ command: "Series", text: "Скрывать произведения цикла «" + _this.seriesTitle + "»", icon: "icon-2-books-stack", checked: true });
                    isHidden = true;
                }
                else {
                    hideOptions.push({ command: "Series", text: "Скрыть произведения цикла «" + _this.seriesTitle + "»", icon: "icon-2-books-stack", checked: false });
                }
            }
            if (_this.authors) {
                for (var authorId in _this.authors) {
                    var hiddenAuthorIds = _this.hiddenAuthorIds();
                    if (hiddenAuthorIds && hiddenAuthorIds.indexOf(parseInt(authorId)) != -1) {
                        hideOptions.push({ command: "Author", authorId: authorId, text: "Скрывать произведения автора «" + _this.authors[authorId] + "»", icon: "icon-user", checked: true });
                        isHidden = true;
                    }
                    else {
                        hideOptions.push({ command: "Author", authorId: authorId, text: "Скрыть произведения автора «" + _this.authors[authorId] + "»", icon: "icon-user", checked: false });
                    }
                }
            }
            _this.isHidden(isHidden);
            return hideOptions;
        });
        this.showHelp = function () {
            app.f7.closeModal();
            app.f7.popover($("#hideButtonHelp")[0], $(_this.element)[0]);
        };
        this.hideHelp = function () {
            app.f7.closeModal($("#hideButtonHelp")[0]);
        };
        this.openPopover = function () {
            app.f7.closeModal();
            app.f7.popover($("#hideBtnPopover")[0], $(_this.element)[0]);
        };
        this.updateHidden = function (args) {
            if (!app.ensureAuth("Чтобы скрыть произведение, необходимо авторизоваться")) {
                return;
            }
            // Режим переключателя единственной сущности
            if (_this.displayMode) {
                args = {
                    checked: _this.isHidden()
                };
                if (_this.workId) {
                    args.command = "Hide";
                }
                else if (_this.seriesId) {
                    args.command = "Series";
                }
                else if (_this.authors) {
                    args.command = "Author";
                    args.authorId = Object.keys(_this.authors)[0];
                }
                else
                    return;
            }
            var libraryButton = _this.workId ? window["AppComponents"].MobileLibraryButton : null;
            var libraryState = libraryButton ? libraryButton.currentState() : "";
            var params = {
                url: "",
                data: {}
            };
            if (_this.processing())
                return;
            _this.processing(true);
            if (libraryButton)
                libraryButton.processing(true);
            if (args.command === "Hide") {
                libraryState = args.checked ? "None" : "Disliked";
                params.url = "work/updateLibrary";
                params.data = {
                    ids: [_this.workId],
                    state: libraryState
                };
            }
            else if (args.command === "Series") {
                params.url = "hide/series";
                params.data = {
                    id: _this.seriesId,
                    deleted: args.checked
                };
            }
            else if (args.command === "Author") {
                params.url = "hide/author";
                params.data = {
                    id: args.authorId,
                    deleted: args.checked
                };
            }
            else
                return;
            app.f7.closeModal($("#hideBtnPopover")[0]);
            ajaxUtils_1.AjaxUtils.post(params.url, params.data).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                else {
                    if (args.command === "Hide") {
                        _this.isDisliked(!args.checked);
                        if (libraryButton)
                            libraryButton.currentState(libraryState);
                    }
                    else if (args.command === "Series") {
                        _this.isSeriesHidden(!args.checked);
                    }
                    else if (args.command === "Author") {
                        var authorId = parseInt(args.authorId);
                        var arr = _this.hiddenAuthorIds();
                        var index = arr.indexOf(authorId, 0);
                        if (index > -1) {
                            arr.splice(index, 1);
                        }
                        if (!args.checked)
                            arr.push(authorId);
                        _this.hiddenAuthorIds(arr);
                    }
                    if (_this.params.showNotification) {
                        alert("Настройки скрытия обновлены.");
                    }
                    if (_this.displayMode)
                        _this.getHideOptions();
                }
            }).always(function () {
                _this.processing(false);
                if (libraryButton)
                    libraryButton.processing(false);
                if (_this.workId)
                    _this.handleRefreshWorkMetaInfo(app, _this.workId);
            });
        };
        this.workId = params.workId;
        this.displayMode = params.displayMode ? params.displayMode : null;
        this.isHidden(false);
        this.isDisliked(params.isDisliked === true);
        this.isSeriesHidden(params.isSeriesHidden === true);
        this.seriesId = params.seriesId;
        this.seriesTitle = params.seriesTitle;
        if (params.hiddenAuthorIds)
            this.hiddenAuthorIds(params.hiddenAuthorIds);
        this.authors = params.authors;
        if (this.displayMode)
            this.getHideOptions();
    }
    return MobileHideButtonComponent;
}(BaseComponent_1.default));
ko.components.register("mobile-hide-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileHideButtonComponent;
//# sourceMappingURL=mobileHideButton.js.map